import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './ProfilePictureDisplay.less';

export const THEME = {
    WHITE: 'theme-white',
    LIGHT_BLUE: 'theme-light-blue'
};

function getUserInitials(user) {
    return user.firstName.charAt(0).toUpperCase() +
        user.lastName.charAt(0).toUpperCase();
}

export class ProfilePictureDisplay extends Component {
    static propTypes = {
        profilePhotoUrl: PropTypes.string,
        user: PropTypes.shape({
            firstName: PropTypes.string.isRequired,
            lastName: PropTypes.string.isRequired
        }).isRequired,

        // Passed in props
        theme: PropTypes.oneOf(Object.values(THEME))
    };

    static defaultProps = {
        theme: THEME.WHITE
    };

    render() {
        const { profilePhotoUrl, theme, user } = this.props;
        const profilePicture = profilePhotoUrl ? (
            <div
                className="ProfilePictureDisplay-wrapper avatar-profile-picture"
                style={{ backgroundImage: `url(${profilePhotoUrl})` }}
            />
        ) : (
            <div className="ProfilePictureDisplay-wrapper default-profile-picture">
                <div className="user-initials">{getUserInitials(user)}</div>
            </div>
        );

        return (
            <div className={`ProfilePictureDisplay ${theme}`}>
                {profilePicture}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    profilePhotoUrl: _.get(state, 'serverData.profilePhoto'),
    user: _.get(state, 'serverData.user')
});

export default connect(mapStateToProps)(ProfilePictureDisplay);
